import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar } from "lucide-react";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { Post } from "@/hooks/usePosts";

const categoryColors: Record<string, string> = {
  fundraising: "bg-green-500/10 text-green-700 dark:text-green-400",
  "community-service": "bg-blue-500/10 text-blue-700 dark:text-blue-400",
  collaboration: "bg-purple-500/10 text-purple-700 dark:text-purple-400",
  education: "bg-orange-500/10 text-orange-700 dark:text-orange-400",
  other: "bg-muted text-muted-foreground",
};

const categoryLabels: Record<string, string> = {
  fundraising: "Fundraising",
  "community-service": "Community Service",
  collaboration: "Collaboration",
  education: "Education",
  other: "Community Impact",
};

const PostCard = ({ post }: { post: Post }) => {
  return (
    <Link to={`/impact/stories/${post.slug}`} className="group block h-full">
      <Card className="h-full flex flex-col hover:shadow-xl transition-all duration-300 overflow-hidden">
        {post.cover_image && (
          <div className="w-full h-48 overflow-hidden bg-muted">
            <img
              src={post.cover_image}
              alt={post.title}
              loading="lazy"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          </div>
        )}
        <CardContent className="p-6 flex-1 flex flex-col">
          <Badge className={categoryColors[post.category] ?? categoryColors.other} style={{ width: "fit-content" }}>
            {categoryLabels[post.category] ?? post.category}
          </Badge>
          <h3 className="text-xl font-semibold mt-3 group-hover:text-primary transition-colors">
            {post.title}
          </h3>
          {post.published_at && (
            <div className="flex items-center gap-2 text-sm text-muted-foreground mt-2">
              <Calendar className="w-4 h-4" />
              <span>{format(new Date(post.published_at), "MMMM d, yyyy")}</span>
            </div>
          )}
          {post.excerpt && (
            <p className="text-sm text-muted-foreground mt-3 line-clamp-3 flex-1">
              {post.excerpt}
            </p>
          )}
          <span className="text-sm font-medium text-primary mt-4">Read story →</span>
        </CardContent>
      </Card>
    </Link>
  );
};

export default PostCard;
